import { render, staticRenderFns } from "./reminders.vue?vue&type=template&id=b9e90a72&scoped=true&"
import script from "./reminders.vue?vue&type=script&lang=js&"
export * from "./reminders.vue?vue&type=script&lang=js&"
import style0 from "./reminders.vue?vue&type=style&index=0&id=b9e90a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e90a72",
  null
  
)

export default component.exports